<div class="m-3">
  <form [formGroup]="form" class="mt-3 row">
    <div class="modal-body modal-scss">
      <form [formGroup]="form" class="mt-3 row">
        <div class="col-md-9 mb-3 p-fluid">
          <label class="input-label d-block"> {{ 'classification.service' | translate }} * </label>
          <p-treeSelect class="w-100 p-treeSelectCreateFolder" [emptyMessage]="'noresult' | translate"
            [(ngModel)]="selectedOption" [ngModelOptions]="{ standalone: true }" #treeSelect [options]="serviceParent"
            selectionMode="single" [placeholder]="'selectADepartment' | translate" appendTo="body"
            (onNodeSelect)="select($event)">
          </p-treeSelect>
        </div>
        <div class="col-md-3 mb-3" *ngIf="type === 'folder'">
          <label class="input-label d-block">
            {{ 'classification.archived' | translate }}
          </label>
          <p-inputSwitch formControlName="archive" binary="true"></p-inputSwitch>
        </div>
        <div class="col-md-12 mb-3">
          <label class="input-label d-block"> {{ 'code' | translate }} * </label>
          <p-dropdown styleClass="w-100" [virtualScroll]="true" virtualScrollItemSize="30" appendTo="body"
            [options]="listCode | sort: 'label' : 'ASC'" [filter]="true" [placeholder]="'selectACode' | translate"
            [showClear]="true" formControlName="classementId">
          </p-dropdown>
        </div>
        <div class="col-md-12 mb-3">
          <label class="input-label d-block"> {{ 'classification.description' | translate }} * </label>
          <textarea rows="5" cols="30" formControlName="description" class="super-compos-input-text form-control w-100"
            pInputTextarea></textarea>
        </div>
        <div class="col-md-12 mb-3">
          <label class="input-label d-block"> {{ 'classification.location' | translate }} </label>
          <input type="text" class="form-control" pInputText formControlName="localisation"
            [placeholder]="'classification.location' | translate" />
        </div>
        <div class="col-md-12 mb-3">
          <label class="input-label d-block"> {{ 'classification.comments' | translate }} </label>
          <textarea rows="3" cols="30" formControlName="remarques" class="super-compos-input-text form-control w-100"
            pInputTextarea></textarea>
        </div>
      </form>
      <div class="d-flex justify-content-end">
        <super-button styleClass="bottomButton red mb-3 me-3" [text]="'global.cancel'|translate"
          (click)="onClose()"></super-button>
        <super-button styleClass="bottomButton green me-3" [disabled]="!form.valid" (click)="createFolder('multiple')"
          [text]="'classification.addSheet' | translate"></super-button>
        <super-button styleClass="bottomButton green" [disabled]="!form.valid" (click)="createFolder('single')"
          [text]="'btn.create'|translate"></super-button>
      </div>
    </div>